
import { PaymentHistoryLog } from './../../common/models/PaymentHistoryLog';
import { DTOBase } from './Dtobase';
import { Data } from '@angular/router';

export class Member extends DTOBase {
    firstName: string;
    middleName: string;
    lastName: string;
    emailAddress: string;
    password: string;
    confirmPassword: string;
    street1: string;
    street2: string;
    postalCode: string;
    city: string;
    country: string;
    purchasedProducts: string;
    sessionId : string;
    membershipExpDate:Date;
    isMemberExist:boolean;
    customerId:string;
    canBuy:string[];
    isMemberExpired: boolean;
}




// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/models/member.ts